import { createMarkdownRenderer } from './markdown_renderer';

export default function AlpineExampleEditor() {
  /**
   * Simple markdown editor for Example Usage section.
   * Provides live preview toggle without autosave — saves via form POST.
   */
  Alpine.data('exampleEditor', (initialContent = '') => ({
    content: initialContent,
    renderedHtml: '',
    showPreview: false,
    renderer: null,

    async init() {
      this.renderer = createMarkdownRenderer();
      if (this.content) {
        await this.renderMarkdown();
      }
    },

    async renderMarkdown() {
      if (this.renderer && this.content) {
        this.renderedHtml = await this.renderer.render(this.content);
      } else {
        this.renderedHtml = '';
      }
    },

    async togglePreview() {
      this.showPreview = !this.showPreview;
      if (this.showPreview) {
        await this.renderMarkdown();
      }
    },
  }));

  /**
   * Editor for Example Output section with text/image mode switching.
   * Manages output type selection and image preview.
   */
  Alpine.data(
    'exampleOutputEditor',
    (initialType = 'text', initialContent = '', initialImageUrl = '') => ({
      outputType: initialType || 'text',
      content: initialContent,
      renderedHtml: '',
      showPreview: false,
      imagePreviewUrl: initialImageUrl,
      selectedFileName: '',
      renderer: null,

      async init() {
        this.renderer = createMarkdownRenderer();
        if (this.content) {
          await this.renderMarkdown();
        }
      },

      async renderMarkdown() {
        if (this.renderer && this.content) {
          this.renderedHtml = await this.renderer.render(this.content);
        } else {
          this.renderedHtml = '';
        }
      },

      async togglePreview() {
        this.showPreview = !this.showPreview;
        if (this.showPreview) {
          await this.renderMarkdown();
        }
      },

      maxFileSize: 5 * 1024 * 1024, // 5MB
      fileSizeError: '',

      onFileSelected(event) {
        const file = event.target.files[0];
        if (file) {
          if (file.size > this.maxFileSize) {
            this.fileSizeError = 'File size too large. Maximum size is 5MB.';
            event.target.value = '';
            return;
          }
          this.fileSizeError = '';
          this._revokePreviewUrl();
          this.selectedFileName = file.name;
          this.imagePreviewUrl = URL.createObjectURL(file);
        }
      },

      _revokePreviewUrl() {
        if (this.imagePreviewUrl?.startsWith('blob:')) {
          URL.revokeObjectURL(this.imagePreviewUrl);
        }
      },

      destroy() {
        this._revokePreviewUrl();
      },

      switchType(type) {
        this.outputType = type;
        this.showPreview = false;
      },
    }),
  );
}
